export default __webpack_public_path__ + "6305c3dc1885a64bd6b8b03b498ace7b.svg";